import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { useLocaleStoreWithOut } from '@/store/modules/locale'
import type { I18n, I18nOptions } from 'vue-i18n'
import { setHtmlPageLang } from './helper'
import zhCN from '../../locales/zh-CN'
import en from '../../locales/en'

export let i18n: ReturnType<typeof createI18n>

/** 与 {@link useLocale} / localStorage `lang` 一致，缺键时回退中文 */
const FALLBACK_LOCALE = 'zh-CN'

const createI18nOptions = async (): Promise<I18nOptions> => {
  const localeStore = useLocaleStoreWithOut()
  const lang = localeStore.getCurrentLocale.lang

  setHtmlPageLang(lang)
  localeStore.setCurrentLocale({ lang })

  return {
    legacy: false,
    locale: lang,
    fallbackLocale: FALLBACK_LOCALE,
    messages: {
      'zh-CN': zhCN as Record<string, unknown>,
      en: en as Record<string, unknown>
    },
    sync: true,
    silentTranslationWarn: true,
    missingWarn: false,
    silentFallbackWarn: true
  }
}

export const setupI18n = async (app: App<Element>) => {
  const options = await createI18nOptions()
  i18n = createI18n(options) as I18n
  app.use(i18n)
}
